// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__146k7","colMin":"styles_colMin__1Zhl1","colCheckbox":"styles_colCheckbox__3FHqz"};